<template>
  <nav class="navbar fixed-top bg-dark navbar-expand-md">
    <div class="container">
      <router-link class="navbar-brand" to="/">
        <img :src="require('@/assets/img/logo_pno.png')" class="d-inline-block" alt="PNO Trailer Rental" width="44" height="40" />
        <span class="navbar-brand-desc d-inline ml-3">Tire Report</span>
      </router-link>
      <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fal fa-lg fa-bars"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <br class="d-md-none">
        <ul class="navbar-nav ml-auto">
	        <li class="nav-item dropdown ml-1 d-none d-md-inline">
	          <a class="nav-link" href="#" id="navbarAccount" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<i class="far fa-lg fa-user-circle d-none d-md-inline"></i><span class="d-md-none">Account</span>
						</a>
	          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarAccount">
              <a v-if="managementUrl" :href="managementUrl" class="dropdown-item px-3" target="_blank">{{managementSiteName}} <small class="pl-1"><i class="far fa-external-link-square"></i></small></a>
              <div class="dropdown-divider"></div>
              <router-link class="dropdown-item px-3" to="/logout">Sign out</router-link>
	          </div>
	        </li>
          <li class="nav-item mx-1 d-md-none">
            <a v-if="managementUrl" :href="managementUrl" class="nav-link" target="_blank">{{managementSiteName}} <small class="pl-1"><i class="far fa-external-link-square"></i></small></a>
            <router-link class="nav-link" to="/logout">Sign out</router-link>
          </li>
        </ul>
        <br class="d-md-none">
      </div>
    </div>
  </nav>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    user: null
  }),
  computed: {
    managementUrl() {
      if (!this.user) {
        return null
      }

      let baseUrl = ''
      if (this.user.claims.pno) {
        baseUrl = window.envConfig.INTERNAL_UI_BASEURL
      } else if (this.user.claims.customer_id) {
        baseUrl = window.envConfig.FLEET_UI_BASEURL
      } else if (this.user.claims.workshop_id) {
        baseUrl = window.envConfig.WORKSHOP_UI_BASEURL
      }

      if (baseUrl === '') {
        return null
      }

      return `${baseUrl}?utm_source=tires`
    },
    managementSiteName() {
      if (this.user.claims.pno) {
        return 'Internal Platform'
      } else if (this.user.claims.customer_id) {
        return 'Fleet Platform'
      } else if (this.user.claims.workshop_id) {
        return 'Workshop Platform'
      }

      return ''
    }
  },
  mounted() {
    this.loadUser().then(user => {
      this.user = user
    })
  },
  methods: {
    ...mapActions('user', ['loadUser'])
  }
}

</script>